// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import PropTypes from 'prop-types';
import HomeHeader from './containers/HomeHeader/HomeHeader';
import MainHeader from './containers/MainHeader/MainHeader';

const Header = ({
  isHomePage,
  data,
  isIndex,
}) => {
  return isHomePage ? (
    <HomeHeader data={data} isIndex={isIndex} />
  ) : (
    <MainHeader data={data} isIndex={isIndex} />
  );
};

Header.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    menu: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      link: PropTypes.string,
    })),
  })),
  isIndex: PropTypes.bool,
  isHomePage: PropTypes.bool,
};

Header.defaultProps = {
  data: [{
    type: 'leftMenu',
    menu: [{
      label: 'no link',
      link: '/',
    }],
  }],
  isIndex: false,
  isHomePage: false,
};

export default Header;
